import {Action} from '@ngrx/store';

export const INITIATE_PROCESS_ACTION = 'INITIATE_PROCESS_ACTION';

export class InitiateProcessActions implements Action {
  readonly type = INITIATE_PROCESS_ACTION;

  constructor(public payload: any) {
  }
}
